import { IUserOrdersServiceProvider } from 'src/modules/users/widgets/user-orders-widget';
import { IAdaptedOrdersList, IRetrieveOrdersRequest } from 'src/modules/users/widgets/user-orders-widget/providers';
import GrpcService from 'src/services/GrpcService';
import { RequestController } from 'src/utils/decorators/request-controller';
import { ordersListAdapter } from '../../adapters/ordersListAdapter';
import {
  GetAvailableTabsResponse,
  ICreateOrderRequest,
  ICreateOrderResponse,
} from '../../orders/pages/order-view/providers/interface';

export class ContractorExternalOrdersProvider implements IUserOrdersServiceProvider {
  getAvailableTabs(): Promise<GetAvailableTabsResponse> {
    throw new Error('Method not implemented.');
  }
  createOrder(req: ICreateOrderRequest): Promise<ICreateOrderResponse> {
    throw new Error('Method not implemented.');
  }

  @RequestController({ logger: true, debounce: true, retry: true })
  async retrieveOrders(request: IRetrieveOrdersRequest): Promise<IAdaptedOrdersList> {
    const res = await GrpcService.ContractorsService.RetrieveCrmOrders({
      limit: request.limit,
      page: request.page,
      where: [{ contractorId: request.userId }],
    });
    return ordersListAdapter(res);
  }
}
